import {Component, OnDestroy, OnInit} from '@angular/core';
import {Select} from '@ngxs/store';
import {AppState} from './state/appState';
import {Observable, Subscription} from 'rxjs';
import {ConfigModel} from './shared/services/config/config.model';
import {filter} from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  @Select(AppState.config$) config$: Observable<ConfigModel>;
  @Select(AppState.loading$) loading$: Observable<boolean>;
  public loading = true;

  private subscriptions: Subscription[] = [];

  constructor(
  ) {
  }

  ngOnInit(): void {
    this.subscriptions.push(this.loading$.pipe(
      filter(l => l != null)
    ).subscribe(l => setTimeout(() => this.loading = l)));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
